<template>
  <TransitionGroup
    name="list"
    tag="div"
    class="toast-scene__container"
  >
    <template v-for="toast in toasts">
      <ExtendedToast
        v-if="toast.extended"
        :id="toast.id"
        :key="toast.id"
        class="toast-pos-center"
        :variant="toast.variant"
        :meta="toast.meta"
      />
      <MinimalToast
        v-else
        :id="toast.id"
        :key="toast.id"
        class="toast-pos-center"
        :variant="toast.variant"
        :meta="toast.meta"
      />
    </template>
  </TransitionGroup>
</template>

<script lang="ts">
export default {
  name: 'Toast',
}
</script>

<script setup lang="ts">
import { computed } from 'vue'

import MinimalToast from './MinimalToast.vue'
import ExtendedToast from './ExtendedToast.vue'
import { useToast } from './useToast'

const toastStore = useToast()

const toasts = computed(() => toastStore.toasts)
</script>

<style lang="scss" scoped>
.toast-scene__container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: transparent;
  pointer-events: none;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  padding: 12px;
  z-index: var(--z-toast-container);
}

.toast-pos-center {
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
}

.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}

.list-enter-active {
  opacity: 0;
  transform: translateY(20px);
}

.list-enter-from {
  transform: translateY(20px);
  opacity: 0;
}
.list-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.list-leave-from {
  opacity: 1;
}
.list-leave-to {
  opacity: 0;
}
</style>
